<template>
  <div>
    <van-loading v-show="loading" size="24" color="#ff6b23" />
    <div v-show="!loading" class="audio-container">
      <audio
        v-if="url"
        ref="audio"
        :src="url"
        preload="metadata"
        @play="onPlay"
        @error="onError"
        @pause="onPause"
        @waiting="onWaiting"
        @playing="onPlaying"
        @timeupdate="onTimeupdate"
        @loadedmetadata="onLoadedmetadata"/>
      <div v-if="!error" class="audio-container__audio" @click="changeProgress">
        <img v-show="!playing" :src="playImg" class="audio-container__audio--icon" @click.stop="play">
        <img v-show="playing" :src="pauseImg" class="audio-container__audio--icon" @click.stop="stop">
        <div class="audio-container__audio--time">
          <span class="time">{{ currentTime | formatTime }}</span>
          <div ref="audioContainer" class="time-bar">
            <span class="time-progress"/>
            <span :style="{left: progressWidth}" class="time-block"/>
          </div>
          <span class="time">{{ (duration - currentTime) | formatTime }}</span>
        </div>
      </div>
      <div v-else class="audio-container__error">
        通话记录获取失败
      </div>
    </div>
  </div>
</template>
<script>
import playImg from '@/assets/img/icon_rec_play@2x.png';
import pauseImg from '@/assets/img/icon_rec_pause@2x.png';

export default {
    name: 'AudioPlayer',
    filters: {
        // 将时间格式化 10:23
        formatTime(time) {
            let t = '00:00';

            if (time > 0) {
                const formatter = (val) => (val < 10 ? `0${val}` : val);

                t = parseInt(time);
                const seconds = formatter(t % 60);
                const minutes = formatter(parseInt(t / 60));

                t = `${minutes}:${seconds}`;
            }

            return t;
        },
    },
    props: {
        // 音频url
        url: {
            type: String,
            required: true,
        },
    },
    data() {
        return {
            progressWidth: 0, // 进度条宽度占比
            playing: false, // 音频是否正在播放
            duration: null, // 音频时长
            currentTime: 0, // 音频当前播放的时间
            loading: true, // 是否在加载中
            error: false, // 是否发生错误
            playImg, // 播放图标
            pauseImg, // 暂停图标
        };
    },
    methods: {
        // 播放按钮
        play() {
            this.playing = true;
            this.$refs.audio.play();
        },
        // 暂停
        stop() {
            this.playing = false;
            this.$refs.audio.pause();
        },
        // 播放音频时的回调函数
        onPlay(data) {
            this.playing = true;
            this.loading = false;
            // 播放目标音频时，暂停其他音频
            const { target } = data;
            const audios = document.getElementsByTagName('audio');

            [...audios].forEach((item) => {
                if (item !== target) {
                    item.pause();
                }
            });
        },
        // 音频暂停时的回调函数
        onPause() {
            this.playing = false;
        },
        // 发生错误时的回调函数
        onError(data) {
			console.error(this.$refs.audio.error)
            this.error = this.$refs.audio.error;
            this.loading = false;
            this.$emit('error', data);
        },
        // 播放过程中的回调函数
        onTimeupdate(data) {
            const { currentTime, duration } = data.target;

            this.currentTime = data.target.currentTime;
            this.progressWidth = `${(currentTime / duration) * 100}%`;
        },
        // 获取元信息后的回调函数
        onLoadedmetadata(data) {
            this.loading = false;
            this.duration = data.target.duration;
        },
        // 数据缓冲时的回调
        onWaiting() {
            this.loading = true;
        },
        // 加载数据后的回调函数
        onPlaying() {
            this.loading = false;
        },
        // 改变进度条
        changeProgress(e) {
            const clickX = e.clientX - this.$refs.audioContainer.getBoundingClientRect().left;
            const { width } = this.$refs.audioContainer.getBoundingClientRect();

            this.currentTime = (clickX / width) * this.duration;
            this.$refs.audio.currentTime = this.currentTime;
            this.progressWidth = `${(clickX / width) * 100}%`;
        },
    },
};
</script>

<style lang="scss" scoped>
  .audio-container {
    position: relative;
    width: 100%;

    &__audio {
      position: relative;
      display: flex;
      align-items: center;
      width: 100%;
      min-width: 282px;
      height: 48px;
      box-sizing: border-box;
      padding: 9px 10px;
      border-radius: 5px;
      background-color: #f5f6f8;
      position: relative;
      overflow: hidden;
      cursor: pointer;

      &--icon {
        width: 30px;
        height: 30px;
        display: block;
        margin-right: 10px;
      }

      &--time {
        position: relative;
        flex: 1;
        display: flex;
        justify-content: space-between;
        align-items: center;
        color: rgb(102, 102, 102);

        .time {
          font-size: 12px;
          color: #999999;
        }

        .time-bar {
          position: relative;
          flex: 1;
          margin: 0 8px;
          height: 10px;

          .time-progress {
            display: inline-block;
            width: 100%;
            position: relative;
            height: 4px;
            background-color: #ffffff;
            vertical-align: super;
          }

          .time-block {
            position: absolute;
            display: inline-block;
            width: 4px;
            height: 10px;
            background-color: #a5a6a9;
          }
        }
      }

      &--progress {
        width: 100px;
        background-color: $primary;
        height: 30px;
        float: left;

        /* transition: width 1s linear; */
      }
    }

    &__error {
      font-size: 13px;
      color: #666666;
    }
  }
</style>
